<template>
  <div class="d d_xm">
    <headers :goBack="goBack" :isForm="1" />
    <van-form @submit="handlerSubmit" @failed="handleFailed">
      <van-field
        required
        name="radio"
        label="今年内是否开展“红领巾奖章”评定颁发？"
        class="radioFlex"
        :rules="[
          {
            required: true,
            message: '请选择今年内是否开展“红领巾奖章”评定颁发',
          },
        ]"
      >
        <template #input>
          <van-radio-group
            v-model="redScarfMedal"
            direction="horizontal"
            v-for="item in yORn"
            v-bind:key="item.key"
            @change="radioChange($event, 'redScarfMedal', clearRedScarfMedal)"
          >
            <van-radio :name="item.key" checked-color="#ff6865">{{
              item.value
            }}</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <div v-if="redScarfMedal == 1">
        <van-field
          v-if="!isZXS && role == 5"
          required
          name="radio"
          label="二星章"
          class="radioFlex"
          :rules="[
            {
              required: true,
              message: '请选择二星章',
            },
          ]"
        >
          <template #input>
            <van-radio-group
              v-model="twoStar"
              direction="horizontal"
              v-for="item in yORn"
              v-bind:key="item.key"
            >
              <van-radio :name="item.key" checked-color="#ff6865">{{
                item.value
              }}</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field
          v-if="isZXS && role == 5"
          required
          name="radio"
          label="二星章或三星章"
          class="radioFlex"
          :rules="[
            {
              required: true,
              message: '请选择二星章或三星章',
            },
          ]"
        >
          <template #input>
            <van-radio-group
              v-model="twoOrThreeStar"
              direction="horizontal"
              v-for="item in yORn"
              v-bind:key="item.key"
            >
              <van-radio :name="item.key" checked-color="#ff6865">{{
                item.value
              }}</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field
          v-if="role == 4"
          required
          name="radio"
          label="三星章"
          class="radioFlex"
          :rules="[
            {
              required: true,
              message: '请选择三星章',
            },
          ]"
        >
          <template #input>
            <van-radio-group
              v-model="threeStar"
              direction="horizontal"
              v-for="item in yORn"
              v-bind:key="item.key"
            >
              <van-radio :name="item.key" checked-color="#ff6865">{{
                item.value
              }}</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field
          v-if="role == 3"
          required
          name="radio"
          label="四星章"
          class="radioFlex"
          :rules="[
            {
              required: true,
              message: '请选择四星章',
            },
          ]"
        >
          <template #input>
            <van-radio-group
              v-model="fourStar"
              direction="horizontal"
              v-for="item in yORn"
              v-bind:key="item.key"
            >
              <van-radio :name="item.key" checked-color="#ff6865">{{
                item.value
              }}</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </div>
      <!--登录按钮-->
      <div style="margin: 16px">
        <van-button round block type="primary" native-type="submit" class="btn btn_dl">
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import { reactive, toRefs, onMounted, getCurrentInstance } from "vue";
import { useRouter, useRoute } from "vue-router";
import headers from "@/components/Header";
import { yORn } from "@/common/js/field";
import { Dialog } from "vant";
import { addForm, getsubmitData, editForm } from "@/service/form";
import store from "@/store";
import { getRoleId, radioChange } from "@/common/js";
import { getKey, encrypt, rsaUtil, serverPublicKey } from "@/common/js";
export default {
  name: "addForm5",
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const route = useRoute();
    let genKeyPair = rsaUtil.genKeyPair();
    window.jsPublicKey = genKeyPair.publicKey;
    window.jsPrivateKey = genKeyPair.privateKey;

    const state = reactive({
      redScarfMedal: null,
      twoStar: null,
      twoOrThreeStar: null,
      threeStar: null,
      fourStar: null,
      province: null,
      role: null,
      zxs: ["北京市", "天津市", "上海市", "重庆市"],
      isZXS: false,
    });
    const whiteList = ["province", "role", "zxs", "isZXS"];
    onMounted(async () => {
      const p = store.state.info && store.state.info.province;
      const r = await getRoleId();
      const { type } = route.query;
      if (type == 1) {
        getInfo();
      }
      if (p) {
        if (state.zxs.indexOf(p) !== -1) {
          state.isZXS = true;
        }
      }
      if (r) {
        state.role = r;
      }
    });
    const getInfo = async () => {
      const { id } = route.query;
      const result = await getsubmitData({ dataId: id });
      const { code, data } = result;
      if (code == 10000 && data) {
        const newObj = {};
        for (const i of data.list) {
          newObj[i.fieldCode] = i.value;
        }
        //   赋值
        Object.assign(state, newObj);
        state.status = data.status;
      }
    };
    const handleFailed = ({values, errors}) => {
      console.log('handleFailed', values, errors)
       Dialog.alert({
        message: "请填写所有必填信息* ~",
      }).then(() => {
        console.log('--33--')
      });
    }
    const handlerSubmit = () => {
      const { type } = route.query;
      Dialog.confirm({
        title: "提示",
        message: "你确定要提交吗？",
      })
        .then(() => {
          proxy.$showLoading();
          if (type == 1) {
            edit(state);
          } else {
            add(state);
          }
        })
        .catch(() => {
          // on cancel
        });
    };
    const edit = async (values) => {
      let arr = [];
      const { id } = route.query;
      let data = {
        id: id,
        formId: 6,
        list: [],
      };
      for (const item in values) {
        let obj = {
          fieldCode: item,
          value: values[item],
        };
        if (whiteList.indexOf(item) !== -1) {
          continue;
        }
        if (values[item]) {
          arr.push(obj);
        }
      }
      data.list = arr;
      //随机获取AES的key
      let aesKey = getKey().toLowerCase();
      let param = {
        encryptData: encrypt(data, aesKey), //AES加密后的数据
        encrypted: rsaUtil.encrypt(aesKey, serverPublicKey), //后端RSA公钥加密后的AES的key
        // publicKey: window.jsPublicKey //前端公钥
      };
      try {
        const res = await editForm(param);
        if (res.code === 10000) {
          proxy.$closeLoading();

          goTo();
        } else {
          proxy.$closeLoading();
        }
      } catch (error) {
        proxy.$closeLoading();
      }
    };
    const add = async (values) => {
      let arr = [];
      // const { id } = route.query;
      let data = {
        formId: 6,
        list: [],
      };

      for (const item in values) {
        let obj = {
          fieldCode: item,
          value: values[item],
        };
        if (whiteList.indexOf(item) !== -1) {
          continue;
        }
        if (values[item]) {
          arr.push(obj);
        }
      }
      data.list = arr;
      console.log("data", data);

      //随机获取AES的key
      let aesKey = getKey().toLowerCase();
      let param = {
        encryptData: encrypt(data, aesKey), //AES加密后的数据
        encrypted: rsaUtil.encrypt(aesKey, serverPublicKey), //后端RSA公钥加密后的AES的key
        // publicKey: window.jsPublicKey //前端公钥
      };
      try {
        const res = await addForm(param);
        if (res.code === 10000) {
          proxy.$closeLoading();
          Dialog.alert({
            message: "您提交的信息已提交审核，审核通过后将自动发布，请等待审核结果~",
          }).then(() => {
            goTo();
          });
        } else {
          proxy.$closeLoading();
        }
      } catch (error) {
        proxy.$closeLoading();
      }
    };
    const goTo = () => {
      // console.log("goTo");
      // const { id } = route.query;
      // if (id) {
      //   router.push({ path: "/info/detail/form5", query: { id } });
      // }
      router.push({ path: "/info/wtg" });
    };
    const clearRedScarfMedal = (val) => {
      if (val == 2) {
        state.twoStar = null;
        state.twoOrThreeStar = null;
        state.threeStar = null;
        state.fourStar = null;
      }
    };

    const goBack = () => {
      router.go(-1);
    };
    return {
      ...toRefs(state),
      yORn,
      goBack,
      handlerSubmit,
      clearRedScarfMedal,
      radioChange,
      handleFailed,
    };
  },
  components: {
    headers,
  },
};
</script>
<style lang="less" scoped>
:deep(.van-cell__value),
:deep(.van-field__control),
:deep(.van-cell__right-icon) {
  color: #ff6865;
}
:deep(.van-radio__icon .van-icon) {
  border: 0.02667rem solid #ff6865 !important;
}
:deep(.van-radio-group--horizontal) {
  padding: 0.188rem 0;
}
</style>
